(function () {
    'use strict';
    angular.module('imAnalytics')
        .constant('DEBUG', function () { /* console.debug(messageObject);*/})
        .constant('OBJECT', false)
        /** POPUP_VIEW VIEW OBJECT DATA DEFINED */
        .constant('POPUP_VIEW', {
            page: {
                pageURL: undefined,
                section: undefined,
                pageType: undefined,
                pageTitle: undefined
            },
            user: {
                isLogged: undefined,
                userId: undefined,
                userType: undefined,
                quickBuy: undefined,
                clientType: undefined
            },
            ecommerce: undefined,
            category: {
                season: undefined,
                category: undefined,
                subcategory: undefined,
                subsubcategory: undefined,
                imtesNumber: undefined,
                viewType: undefined
            },
            product: {
                reference: undefined,
                productState: undefined,
                claseProducto: undefined,
                consumerProduct: undefined,
                onlineOnly: undefined,
                stock: undefined,
                color: undefined,
                model: undefined,
                key: undefined
            },
            photo: {
                typePhoto: undefined,
                linkType: undefined,
                lightType: undefined,
                background: undefined
            },
            look: {
                lookReference: undefined,
                camapanaReference: undefined,
                bundleReference: undefined,
                referencia_foto: undefined
            },
            searchEngine: {
                searchTerm: undefined,
                searchResultNr: undefined
            },
            cart: {
                cartNumberItems: undefined,
                cartNumberItemsNoStock: undefined,
                cartProducts: {
                    reference: undefined,
                    quantity: undefined
                }
            },
            paymentObject: {
                type: undefined,
                giftcardAmount: undefined,
                affinity: undefined,
                netAmount: undefined,
                savedData: undefined,
                savedDataCheck: undefined,
                giftTicket: undefined
            },
            deliveryObject: {
                shippingType: undefined,
                weekday: undefined,
                time: undefined
            },
            orderObject: {
                orderId: undefined,
                payment: {

                },
                delivery: {
                    shippingType: undefined,
                    weekday: undefined,
                    time: undefined
                },
                discount: {
                    discountType: undefined,
                    fullAmount: undefined
                },
            },
            store: {
                storeFound: undefined,
                storeId: undefined
            }

        })
        /** END POPUP_VIEW VIEW OBJECT DATA DEFINED */

        /** PAGE_VIEW VIEW OBJECT DATA DEFINED */
        .constant('PAGE_VIEW', {
            context: {
                platform: undefined,
                codeVersion: undefined,
                storeId: undefined,
                language: undefined,
                isOpenStore: undefined
            },
            page: {
                pageURL: undefined,
                section: undefined,
                pageType: undefined,
                pageTitle: undefined,
                countryCode: undefined,
                categoryId: undefined
            },
            user: {
                isLogged: undefined,
                userId: undefined,
                userType: undefined,
                quickBuy: undefined,
                isBuyer: undefined,
                clientType: undefined
            },
            category: {
                season: undefined,
                category: undefined,
                subcategory: undefined,
                subsubcategory: undefined,
                imtesNumber: undefined,
                viewType: undefined,
                filter: undefined,
                sortType: undefined
            },
            ecommerce: undefined,
            product: {
                reference: undefined,
                productState: undefined,
                claseProducto: undefined,
                consumerProduct: undefined,
                onlineOnly: undefined,
                stock: undefined,
                color: undefined,
                talla: undefined,
                model: undefined,
                key: undefined
            },
            photo: {
                typePhoto: undefined,
                linkType: undefined,
                lightType: undefined,
                background: undefined
            },
            look: {
                lookReference: undefined,
                camapanaReference: undefined,
                bundleReference: undefined,
                referencia_foto: undefined
            },
            searchEngine: {
                searchTerm: undefined,
                searchResultNr: undefined
            },
            cart: {
                cartNumberItems: undefined,
                cartNumberItemsNoStock: undefined,
                cartProducts: undefined
            },
            order: {
                orderId: undefined,
                payment: {
                    type: undefined,
                    giftcardAmount: undefined,
                    affinity: undefined,
                    netAmount: undefined,
                    savedData: undefined,
                    giftTicket: undefined
                },
                delivery: {
                    shippingType: undefined,
                    weekday: undefined,
                    time: undefined
                },
                discount: {
                    discountType: undefined,
                    fullAmount: undefined
                },
            },
            store: {
                storeFound: undefined,
                zipCode: undefined,
                storeId: undefined
            }
        })
        /** END PAGE_VIEW VIEW OBJECT DATA DEFINED */

        /**  ANALITYCS_EVENT VIEW OBJECT DATA DEFINED */
        .constant('ANALYTICS_EVENT', {
            eventData: {
                cf: undefined,
                category: undefined,
                action: undefined,
                label: undefined
            },
            ecommerce: undefined,
            customData: {
                user: {
                    userId: undefined,
                    userType: undefined,
                    quickBuy: undefined,
                    clientType: undefined,
                    isBuyer: undefined,
                    sex: undefined,
                    age: undefined
                },
                category: {
                    season: undefined,
                    subcategory: undefined,
                    itemsNumber: undefined,
                    viewType: undefined,
                    filter: undefined,
                    sortType: undefined
                },
                product: {
                    reference: undefined,
                    productState: undefined,
                    claseProducto: undefined,
                    consumerProduct: undefined,
                    color: undefined,
                    talla: undefined,
                    model: undefined,
                    stock: undefined,
                    key: undefined
                },
                cart: {
                    cartNumberItems: undefined,
                    cartNumberItemsNoStock: undefined,
                    cartProducts: [{
                        reference: undefined,
                        quantity: undefined
                    }]
                },
                order: {
                    orderId: undefined,
                    orderState: undefined,
                    payment: {
                        savedData: undefined,
                        giftTicket: undefined
                    },
                    discount: {
                        discountType: undefined
                    },
                },
                look: {
                    lookReference: undefined,
                    bundleReference: undefined,
                    videoName: undefined,
                    campanaReference: undefined,
                    referencia_data: undefined
                },
                store: {
                    zipCode: undefined,
                    storeId: undefined,
                    dropPoint: undefined
                },
                giftCard: {
                    amountEcard: undefined,
                    amountFisica: undefined
                },
                searchEngine: {
                    searchTerm: undefined
                },
                photo: {
                    typePhoto: undefined,
                    linkType: undefined,
                    lightType: undefined,
                    background: undefined
                },
            }
        })
        /** END ANALITYCS_EVENT OBJECT DATA DEFINED */
        .constant('IMPRESSION', {
            name: undefined,
            id: undefined,
            price: undefined,
            category: undefined,
            list: undefined,
            position: undefined,
            dimension96: undefined
        })
        /**  IMPRESSION OBJECT DATA DEFINED */
        .constant('IMPRESSIONS', {
            ecommerce: {
                currencyCode: undefined,
                impressions: []
            }
        })
        /**  END IMPRESSION OBJECT DATA DEFINED */
        /**  VIRTUAL_PAGE  OBJECT DATA DEFINED */
        .constant('VIRTUAL_PAGE', {
            page: {
                pageURL: undefined,
                section: undefined,
                pageType: undefined,
                pageTitle: undefined
            },
            ecommerce: undefined,
            customData: undefined
        })
        /** END VIRTUAL_PAGE  OBJECT DATA DEFINED */
        /** PRODUCT OBJECT DATA DEFINED */
        .constant('PRODUCT', {
            name: undefined,
            id: undefined,
            price: undefined,
            category: undefined,
            position: undefined,
            dimension96: undefined
        })
        /** END PRODUCT OBJECT DATA DEFINED */
        /** PRODUCT_CLICK OBJECT DATA DEFINED */
        .constant('PRODUCT_CLICK', {
            ecommerce: {
                currencyCode: undefined,
                click: {
                    actionField: {
                        list: undefined
                    },
                    products: []//HERE PRODUCT
                },
            }
        })
        /** END PRODUCT_CLICK OBJECT DATA DEFINED */
        /** SEARCH_CLICK OBJECT DATA DEFINED */
        .constant('SEARCH_CLICK', {
            ecommerce: {
                currencyCode: undefined,
                click: {
                    actionField: {
                        list: undefined
                    },
                    products: []//HERE PRODUCT
                },
            }
        })
        /** END SEARCH_CLICK OBJECT DATA DEFINED */
        /** PRODUCT_DETAIL OBJECT DATA DEFINED */
        .constant('PRODUCT_DETAIL', {
            ecommerce: {
                currencyCode: undefined,
                detail: {
                    actionField: {
                        list: undefined
                    },
                    products: []//HERE PRODUCT
                },
            }
        })
        /** END PRODUCT_DETAIL OBJECT DATA DEFINED */
        /** PRODUCTS OBJECT DATA DEFINED */
        .constant('PRODUCTS', {
            name: undefined,
            id: undefined,
            price: undefined,
            category: undefined,
            position: undefined,
            quantity: undefined,
            dimension96: undefined,
            dimension97: undefined,
        })
        /**END PRODUCTS OBJECT DATA DEFINED */
        /** ADD_CART OBJECT DATA DEFINED */
        .constant('ADD_CART', {
            ecommerce: {
                currencyCode: undefined,
                add: {
                    actionField: {
                        list: undefined
                    },
                    products: [] //HERE PRODUCTS
                }
            }

        })
        /** END ADD_CART OBJECT DATA DEFINED */
        /** REMOVE_CART OBJECT DATA DEFINED */
        .constant('REMOVE_CART', {
            ecommerce: {
                currencyCode: undefined,
                remove: {
                    actionField: {
                        list: undefined
                    },
                    products: []//HERE PRODUCTS
                },
            }
        })
        /** END REMOVE_CART OBJECT DATA DEFINED */
        /** CHECKOUT OBJECT DATA DEFINED */
        .constant('CHECKOUT', {
            ecommerce: {
                currencyCode: undefined,
                checkout: {
                    actionField: {
                        step: undefined,
                    },
                    products: [],//HERE LIST OF PRODUCTS
                }
            }
        })
        /** END CHECKOUT OBJECT DATA DEFINED */
        /** PURCHASE OBJECT DATA DEFINED */
        .constant('PURCHASE', {
            ecommerce: {
                currencyCode: undefined,
                purchase: {
                    actionField: {
                        id: undefined,
                        revenue: undefined,
                        shipping: undefined,
                        tax: undefined,
                    },
                    products: []//HERE LIST OF PRODUCTS
                }
            }
        });
    /** END PURCHASE OBJECT DATA DEFINED */

    /** END OF FILE constant */
})();
